module.exports = __webpack_public_path__ + "static/media/sitHereArrow.efebac81.svg";